import { useState } from "react";
import { Plus } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { http, errMsg } from "@/lib/api";

export default function AddPropertyDialog({ onCreated }) {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ name: "", city: "", area: "", stars: 3, commission_percent: 0, notify_emails: "" });
  const set = (k) => (e) => setF({ ...f, [k]: ["stars", "commission_percent"].includes(k) ? Number(e.target.value) : e.target.value });
  const save = async () => {
    try {
      const { data } = await http.post("/extranet/properties", { ...f, notify_emails: f.notify_emails.split(",").map((s) => s.trim()).filter(Boolean), address: f.area, free_cancellation: true, cancellation_policy: "Pembatalan gratis hingga 24 jam sebelum check-in." });
      toast.success("Properti ditambahkan");
      setOpen(false); setF({ name: "", city: "", area: "", stars: 3, commission_percent: 0, notify_emails: "" });
      onCreated(data.id);
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button data-testid="add-property-button" className="flex items-center gap-1.5 rounded-md border border-[#006CE4] bg-white px-3 py-2 text-sm font-semibold text-[#006CE4] hover:bg-blue-50"><Plus className="h-4 w-4" /> Tambah properti</button>
      </DialogTrigger>
      <DialogContent className="extranet" data-testid="add-property-dialog">
        <DialogHeader><DialogTitle>Tambah properti baru</DialogTitle></DialogHeader>
        <div className="grid gap-4 sm:grid-cols-2">
          <div className="sm:col-span-2"><Label>Nama properti</Label><Input data-testid="new-prop-name" value={f.name} onChange={set("name")} className="mt-1.5" /></div>
          <div><Label>Kota</Label><Input data-testid="new-prop-city" value={f.city} onChange={set("city")} className="mt-1.5" /></div>
          <div><Label>Area</Label><Input data-testid="new-prop-area" value={f.area} onChange={set("area")} className="mt-1.5" /></div>
          <div><Label>Bintang (1-5)</Label><Input data-testid="new-prop-stars" type="number" min={1} max={5} value={f.stars} onChange={set("stars")} className="mt-1.5" /></div>
          <div><Label>Komisi Booking Engine (%)</Label><Input data-testid="new-prop-commission" type="number" min={0} max={50} step="0.5" value={f.commission_percent} onChange={set("commission_percent")} className="mt-1.5" /></div>
          <div className="sm:col-span-2"><Label>Email konfirmasi ke hotel (pisahkan koma, maks 5)</Label><Input data-testid="new-prop-notify-emails" value={f.notify_emails} onChange={set("notify_emails")} placeholder="reservasi@hotel.com, gm@hotel.com" className="mt-1.5" /></div>
        </div>
        <DialogFooter><button data-testid="new-prop-save" onClick={save} className="rounded-md bg-[#006CE4] px-5 py-2 font-semibold text-white hover:bg-[#0052B4]">Buat properti</button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
